import { MkIcon } from "@/mk/MkIcon";
import { Fragment } from "react";

import type { Crumb } from "./types";

export function MkBreadcrumb({ items, onSelect, className }: {
    items: Crumb[];
    onSelect?(id: string, item: Crumb): void;
    className?: string;
}) {
    return (
        <nav className={`mk-breadcrumb${className ? ` ${className}` : ""}`}>
            {items.map((item, index) => {
                const last = index === items.length - 1;
                const current = last && !item.home;
                return (
                    <Fragment key={index}>
                        <button className={`mk-crumb${current ? " mk-crumb-current" : ""}`}
                                disabled={current}
                                title={item.label} aria-label={item.label} aria-current={current ? "page" : undefined}
                                onClick={() => onSelect?.(item.id, item)}>
                            <MkIcon name={item.icon || "fa-file-o"} className={item.icon ? undefined : "mk-crumb-fallback"} />
                            <span className="mk-crumb-label">{item.label}</span>
                        </button>
                        {!last && <MkIcon name="fa-angle-right" className="mk-crumb-sep" />}
                    </Fragment>
                );
            })}
        </nav>
    );
}
